import { Link, NavLink } from "react-router-dom";

function Header() {
  return (
    <>
      <nav className="navbar navbar-expand-lg p-0 sticky-top my-header-bg z-5">
        <div className="container py-1">
          <div className="d-flex align-items-center">
            <Link to="/">
              <img
                src="/assets/images/logo.png"
                className="d-lg-none d-block"
                width="120"
              />
              <img
                src="/assets/images/logo.png"
                width="160"
                className="me-5 d-lg-block d-none"
              />
            </Link>
          </div>
          <div className="ms-auto d-flex align-items-center order-lg-3">
            <div>
              <div className="d-flex align-items-center">
                <div class="d-flex gap-2 align-items-center justify-content-end me-lg-5">
                  <a href="https://www.facebook.com/profile.php?id=61583614931392" target="_blank"><i className="bi bi-facebook text-dark fs-4 me-3"></i></a>
                  <a href="https://www.instagram.com/go_wiith_traveelbug?igsh=MjA1a2djc3ppdTJ1" target="_blank"><i className="bi bi-instagram text-dark fs-4 me-3"></i></a>
                </div>
                <a
                  href="tel: +919009062040"
                  className="btn bg-primary text-white fw-normal rounded-pill d-none d-md-block me-2 px-4 me-lg-0"
                >
                  Contact Us
                </a>
                <img
                  src="/assets/images/icon.png"
                  width="50"
                  className="ms-4"
                />
              </div>
            </div>
          </div>
          <div className="collapse navbar-collapse" id="navbar-default">
            <ul className="navbar-nav  mt-3 mt-lg-0 ms-4">
              <li className="nav-item">
                <NavLink to="/" className="nav-link ps-0">
                  Home
                </NavLink>
              </li>
              <li className="nav-item">
                <a href="#why-traveel-bug" className="nav-link">
                  Why Traveel Bug
                </a>
              </li>
              <li className="nav-item">
                <a href="#destinations" className="nav-link">
                  Destinations
                </a>
              </li>
              <li className="nav-item">
                <a href="#about-us" className="nav-link">
                  About Us
                </a>
              </li>
              <li className="nav-item">
                <a href="#booking-process" className="nav-link">
                  Booking Process
                </a>
              </li>
              <li className="nav-item">
                <Link to="/" className="nav-link">
                  FAQs
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      <div className="d-flex justify-content-end position-relative">
        <div className="position-fixed z-5 top-35 d-flex flex-column align-items-end width-fit-content">
          <a
            href="https://api.whatsapp.com/send?phone=919009062040&text=Hi"
            target="_blank"
            className="btn btn-white shadow rounded-end-0 rounded-start-pill px-3 mb-2"
          >
            <img
              src="https://cdn-icons-png.flaticon.com/512/3992/3992601.png"
              width="40"
              className="rounded-5"
            />
          </a>
          <a
            href="tel: +917987272900"
            className="btn btn-white shadow rounded-end-0 rounded-start-pill px-3"
          >
            <img
              src="https://cdn-icons-png.flaticon.com/512/3178/3178496.png"
              width="40"
              className="rounded-5"
            />
          </a>
        </div>
      </div>
    </>
  );
}

export default Header;
